export enum StorageKey {
  WebStoreGuestToken = 'web-store-guest-token',
  WebStoreAuthToken = 'web-store-auth-token',
  CustomerGuestId = 'customer-guest-id',
  CustomerAuthId = 'customer-auth-id',
}
